import { render, staticRenderFns } from "./ToggleListComponent.vue?vue&type=template&id=bddde23a&scoped=true&"
import script from "./ToggleListComponent.vue?vue&type=script&lang=js&"
export * from "./ToggleListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToggleListComponent.vue?vue&type=style&index=0&id=bddde23a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddde23a",
  null
  
)

export default component.exports